import withTranslation from '/provider/TranslationProvider/withTranslation';

let toastContainer: HTMLElement | null = null;

function getOrCreateToastContainer(): HTMLElement {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'web-toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      pointer-events: none;
    `;
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

export class ToastUtil {
  static show({
    message,
    duration = 3000,
  }: {
    type: 'success' | 'error' | 'info';
    message: string;
    duration?: number;
  }) {
    const container = getOrCreateToastContainer();

    const toast = document.createElement('div');
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText = `
      background-color: #000000;
      color: #FFFFFF;
      padding: 12px 24px;
      border-radius: 8px;
      margin-bottom: 10px;
      font-size: 14px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      pointer-events: auto;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      max-width: 400px;
    `;
    toast.textContent = message;

    container.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '1';
    }, 10);

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, duration);
  }
}

export const showToast = (key: any, defaultValue: any) => {
  const message = String(withTranslation.ts(`toast.${key}`, defaultValue));

  ToastUtil.show({
    type: 'success',
    message,
    duration: 3000,
  });
};

// export const showComingSoonToast = (elementName: any) => {
//   showToast('comingSoon', 'Coming soon');

//   getAnalyticsUtilDefaultInstance().trackNonFunctionalClick({
//     elementName,
//   });
// };

// export const showDataPointsComingSoonToast = (elementName: any) => {
//   showToast('dataComingSoon', 'Additional data points coming soon');

//   getAnalyticsUtilDefaultInstance().trackNonFunctionalClick({
//     elementName,
//   });
// };

export const showCopiedToClipboardToast = () => {
  showToast('copiedToClipboard', 'Copied to clipboard');
};

// export const showCandidateSavedToast = () => {
//   showToast('Success', 'Candidate saved successfully');
// };

// =============================================================================
// Business Account Management (BAM) Toasts
// =============================================================================

export const showProfileSaveSuccessToast = () => {
  showToast('saveSuccess', 'Profile changes updated successfully');
};

export const showProfileSaveErrorToast = () => {
  showToast(
    'profileSaveError',
    'Failed to update profile changes. Please try again.',
  );
};

export const showSocialLinksSaveSuccessToast = () => {
  showToast('saveSuccess', 'Social media links updated successfully');
};

export const showSocialLinksSaveErrorToast = () => {
  showToast(
    'socialLinksSaveError',
    'Failed to update social media links. Please try again.',
  );
};

export const showUploadSuccessToast = () => {
  showToast('uploadSuccess', 'Photo uploaded successfully');
};

export const showUploadErrorToast = () => {
  showToast('uploadError', 'Failed to upload photo. Please try again.');
};

export const showSupportedLanguagesSaveSuccessToast = () => {
  showToast(
    'supportedLanguagesSaveSuccess',
    'Supported Languages updated successfully',
  );
};

export const showSupportedLanguagesSaveErrorToast = () => {
  showToast(
    'supportedLanguagesSaveError',
    'Failed to update languages. Please try again.',
  );
};

export const showLeadsPoolSaveSuccessToast = () => {
  showToast(
    'leadsPoolSaveSuccess',
    'Leads pool preference updated successfully',
  );
};

export const showLeadsPoolSaveErrorToast = () => {
  showToast(
    'leadsPoolSaveError',
    'Failed to update leads pool preference. Please try again.',
  );
};

export const showHealthcareSaveSuccessToast = () => {
  showToast(
    'healthcareSaveSuccess',
    'Healthcare information saved successfully',
  );
};

export const showHealthcareSaveErrorToast = () => {
  showToast(
    'healthcareSaveError',
    'Failed to update healthcare information. Please try again.',
  );
};

// =============================================================================
// End of Business Account Management (BAM) Toasts
// =============================================================================
